module.exports = __webpack_public_path__ + "fonts/memnYaGs126MiZpBA-UFUKWiUNhmIqOjjg.4057f7b7.woff2";